<script>
import { Bar, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import moment from 'moment'

export default {
  extends: Bar,
  props: ['height', 'options', 'chartData'],
  mixins: [mixins.reactiveProp],

  mounted () {
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'

    const chartColorScheme = [
      '#20c997',  // teal
      '#17a2b8',  // cyan
      '#6f42c1',  // purple
      '#ffc107',  // brand warning (yellow)
      '#c8ced3',  // gray 300
      '#63c2de',  // brand secondary (light blue)
      '#6610f2',  // indigo
      '#73818f',  // gray 600
    ]

    let d = this.chartData;
    // console.log(d)

    let channel = {
      label: 'channel messages',
      // backgroundColor: brandSuccess,
      data: []
    }
    let direct = {
      label: 'direct messages',
      // backgroundColor: brandInfo,
      data: []
    }
    let mpim = {
      label: 'mpim messages',
      // backgroundColor: brandDanger,
      data: []
    }
    let totalCount = {
      label: 'total messages',
      data: []
    }
    let xAxisLabels = []

    let options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }
    Object.keys(d).forEach(function(key) {
      // add label
      xAxisLabels.push(moment.unix(key).format('MMM Do hA'))

      // now fill in data
      let row = d[key]
      channel.data.push(row.channel)
      direct.data.push(row.direct)
      mpim.data.push(row.mpim)
      totalCount.data.push(row.channel + row.direct + row.mpim)

    })

    this.renderChart({
      labels: xAxisLabels,
      // datasets: [channel, direct, mpim, totalCount],
      datasets: [totalCount]
    }, 
    // chart options
    {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 24 // this will need to be dynamic based on time window
          }
          
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true,
            precision: 0,
          },
          gridLines: {
            display: true
          }
        }]
      },

      plugins: {
        colorschemes: {
          scheme: chartColorScheme
        }
      }

    })
        
  }
}
</script>
